import vitaziLogo from '@/assets/images/03_Vitazi.ai logo_white_Transparent.png';
import type { TelehealthReportData } from '@/api/print/types';

type ReportHeaderProps = {
  data: TelehealthReportData;
};

export function ReportHeader({ data }: ReportHeaderProps) {
  const { patient, dates, grade } = data;

  return (
    <div className="mb-1 shrink-0">
      {/* Top section: title + info on left, logo on right */}
      <div className="flex justify-between items-start mb-1">
        <div>
          <h1 className="text-xl font-bold text-[#152644] mb-1">Vitazi Report</h1>
          <p className="text-xs text-gray-700 leading-4">
            Case Submitted: {dates.case_submitted_formatted}
          </p>
          <p className="text-xs text-gray-700 leading-4">
            Case Evaluated: {dates.case_evaluated_formatted}
          </p>
          <p className="text-xs text-gray-700 leading-4">Patient DOB: {patient.patient_dob}</p>
          <p className="text-xs text-gray-700 leading-4">Patient Name: {patient.patient_name}</p>
        </div>
        <img src={vitaziLogo} alt="Vitazi.ai" className="h-28 w-28 object-contain" />
      </div>

      {/* Follow-up recommendation */}
      <p className="text-xs font-bold text-gray-900 mb-1">
        Follow Up Recommendation: {grade.follow_up.combined_label}
      </p>

      {/* Separator bars */}
      <div className="w-full h-1.5 bg-[#152644]" />
      <div className="w-full h-px bg-[#8cc3e1]" />
    </div>
  );
}
